import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ZoomInIcon, XIcon } from 'lucide-react';
import { reviews, Review } from '../data/reviews';
export function ReviewsGallery() {
  const [lightbox, setLightbox] = useState<Review | null>(null);
  return <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-324">
        {reviews.map((r, index) => <motion.button key={r.id} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4,
        delay: index % 3 * 0.08
      }} onClick={() => setLightbox(r)} className="group flex flex-col bg-white rounded-[20px] shadow-card hover:shadow-card-hover transition-all duration-300 overflow-hidden border border-brand-beige hover:border-brand-gold/40 hover:-translate-y-1 p-4" data-id="element-325">
            <div className="relative w-full aspect-[3/4] bg-brand-beige/20 rounded-[12px] overflow-hidden flex items-center justify-center" data-id="element-326">
              <img src={r.image} alt="Recenzie client" className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-[1.02]" data-id="element-327" />
              <div className="absolute inset-0 bg-brand-navy/0 group-hover:bg-brand-navy/15 transition-colors duration-300 flex items-center justify-center pointer-events-none" data-id="element-328">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white rounded-full p-3 shadow-lg" data-id="element-329">
                  <ZoomInIcon size={20} className="text-brand-navy" data-id="element-330" />
                </div>
              </div>
            </div>
          </motion.button>)}
      </div>

      <AnimatePresence data-id="element-331">
        {lightbox && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setLightbox(null)} className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 cursor-zoom-out" data-id="element-332">
            <button onClick={e => {
          e.stopPropagation();
          setLightbox(null);
        }} className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors z-10" aria-label="Închide" data-id="element-333">
              <XIcon size={24} data-id="element-334" />
            </button>
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="max-w-3xl w-full flex flex-col items-center gap-4" onClick={e => e.stopPropagation()} data-id="element-335">
              <img src={lightbox.image} alt="Recenzie client" className="max-w-full max-h-[85vh] object-contain rounded-[12px] shadow-2xl" data-id="element-336" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}